module.exports = __webpack_public_path__ + "img/01.0cba38e2.jpg";